import { IconLock } from "@suse-o11y/icons";
import React from "react";

import { Messages } from "../../../common/Messages";

export interface LockedNodeModalMessageProps {
	nodeType: string;
}

export const LockedNodeModalMessage: React.FC<LockedNodeModalMessageProps> = ({ nodeType }) => {
	const type = Messages.nodeTypeName(nodeType);

	return (
		<div className="flex">
			<IconLock className="-mt-4 mr-4 text-[6rem] text-orange-500" />
			<div data-testid="locked-node-modal-description-message">
				<div className="mb-2 font-bold">{Messages.lockedNode(nodeType)}</div>

				<p>
					By proceeding to edit or remove this {type}, you may introduce changes that prevent this StackPack from
					upgrading correctly.
				</p>
				<p>
					Any changes you make are not the responsibility of the StackPack developer. If you want to make changes to the
					StackPack, please contact the developer of the StackPack.
				</p>
			</div>
		</div>
	);
};
